/**
 * Shared BYOB progress bar logic (bundle page sidebar + cart drawer).
 * Keep tier defaults in sync with templates/page.build-your-bundle.json.
 */
(function (global) {
  var DEFAULT_TIERS = [
    { min: 3, max: 4, discount: 5 },
    { min: 5, max: 6, discount: 10 },
    { min: 7, max: 999, discount: 15 }
  ];

  function parseTiers(raw) {
    if (!raw) return DEFAULT_TIERS.slice();
    try {
      var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return Array.isArray(parsed) && parsed.length ? parsed : DEFAULT_TIERS.slice();
    } catch (e) {
      return DEFAULT_TIERS.slice();
    }
  }

  function getProgressFillPercent(n, tiers) {
    if (!tiers.length || n <= 0) return 0;

    var thresholds = tiers.map(function (t) { return Math.max(1, t.min); });
    var tierCount = tiers.length;

    function markerPosition(index) {
      return ((index + 1) / tierCount) * 100;
    }

    var firstThreshold = thresholds[0];
    if (n <= firstThreshold) {
      return (n / firstThreshold) * markerPosition(0);
    }

    for (var i = 0; i < tierCount - 1; i++) {
      var currentThreshold = thresholds[i];
      var nextThreshold = thresholds[i + 1];
      if (n <= nextThreshold) {
        var ratio = (n - currentThreshold) / (nextThreshold - currentThreshold);
        return markerPosition(i) + ratio * (markerPosition(i + 1) - markerPosition(i));
      }
    }

    return markerPosition(tierCount - 1);
  }

  function getDiscountPercent(n, tiers) {
    var percent = 0;
    tiers.forEach(function (tier) {
      if (n >= tier.min) percent = tier.discount;
    });
    return percent;
  }

  function render(container, itemCount, tiers) {
    if (!container) return;
    tiers = tiers || DEFAULT_TIERS;

    var n = Math.max(0, itemCount);
    var fillPercent = getProgressFillPercent(n, tiers);
    var firstThreshold = tiers.length ? Math.max(1, tiers[0].min) : 3;
    if (n > 0 && n < firstThreshold && fillPercent < 10) fillPercent = 10;

    var progressBar = container.querySelector('[data-byob-progress]');
    var progressFill = container.querySelector('[data-byob-progress-fill]');
    var segmentsEl = container.querySelector('[data-byob-progress-segments]');
    if (!progressBar || !progressFill) return;

    progressBar.setAttribute('data-byob-items', String(n));
    var pct = fillPercent.toFixed(2) + '%';
    progressFill.setAttribute('data-fill-pct', pct);
    progressFill.style.setProperty('width', pct, 'important');
    progressFill.style.setProperty('min-width', n > 0 ? '8px' : '0', 'important');

    if (segmentsEl) {
      segmentsEl.innerHTML = '';
      tiers.forEach(function (tier) {
        var exact = tier.exact === true;
        var achieved = exact ? (n === tier.min) : (n >= tier.min);
        var itemsDisplay = exact ? String(tier.min) : (tier.max >= 999 ? tier.min + '+' : String(tier.min));
        var seg = document.createElement('div');
        seg.className = 'byob__progress-segment' + (achieved ? ' is-achieved' : '');
        seg.setAttribute('data-tier-min', tier.min);
        seg.innerHTML = '<span class="byob__progress-segment-arrow" aria-hidden="true"></span>' +
          '<div class="byob__progress-segment-lines">' +
          '<span class="byob__progress-segment-items">' + itemsDisplay + ' items</span>' +
          '<span class="byob__progress-segment-discount">' + tier.discount + '% off</span>' +
          '</div>';
        segmentsEl.appendChild(seg);
      });
    }
  }

  global.BYOBProgressBar = {
    DEFAULT_TIERS: DEFAULT_TIERS,
    parseTiers: parseTiers,
    getProgressFillPercent: getProgressFillPercent,
    getDiscountPercent: getDiscountPercent,
    render: render
  };
})(typeof window !== 'undefined' ? window : this);
